import { ProjectDocQuery } from "../models/ProjectDocQuery";

export function projectDocQueryToTableFilters(q: ProjectDocQuery) {
  return {
    filters: {
      TitleContains: { value: q.TitleContains ?? ``, matchMode: `contains` },
      ProjectTitle: { value: q.ProjectTitle ?? ``, matchMode: `contains` },
      DocTypeId: { value: q.DocTypeId, matchMode: `equals` },
      StatusIds: { value: q.StatusIds ?? [], matchMode: `in` },
      CreatedQueryParams: { value: q.CreatedQueryParams, matchMode: `custom` },
    },
    multiSortMeta: (q.Sorts ?? []).map((s) => ({ field: s.Field, order: s.Desc ? 1 : -1 })),
  };
}
